import { useTranslation } from 'next-i18next'
import { Fragment } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Link } from '~/components'

import { subjects } from './Subjects.const'
import useSubjects from './useSubjects'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '48px' }]

export default function Subjects({ className = '' }): React.ReactElement {
  const { t } = useTranslation(['generics', 'tutorOnDemand'])
  const background = useSubjects()

  const style = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
  }

  return (
    <Fragment>
      <div className={`${className}`} style={style}>
        <div className="max-w-5xl mx-auto">
          <h2 className="mb-6 text-left text-lg sm:text-h3 font-semibold text-white">
            {t('tutorOnDemand:landingPage.subjects.title')}
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-8">
            {subjects.map(({ name, href, icon }) => (
              <Link className="rounded transition ring-0 hover:ring ring-gray-light bg-white" key={name} to={href}>
                <div className="h-full p-4 flex flex-col-reverse sm:flex-row gap-y-1 items-center justify-between">
                  <span className="text-md font-medium text-black-light">{t(`generics:subjects.${name}`)}</span>
                  <ResponsiveImage
                    alt={`${t(`generics:subjects.${name}`)}-${t('generics:icon')}`}
                    height={48}
                    imageClassName="h-12"
                    imageWidths="48"
                    mediaQuery={mediaQuery}
                    srcKey={icon}
                    width={48}
                  />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="max-w-lg mx-auto p-4">
        <p className="mt-6 sm:text-md leading-8">{t('tutorOnDemand:landingPage.subjects.text')}</p>
      </div>
    </Fragment>
  )
}
